module.exports = "/img/ball.svg?e00167cb931c1735d07d719354a3d278";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/ball.svg
// module id = 7q+X
// module chunks = 60